export default __webpack_public_path__ + "static/media/cloud-icon.8235fb94.svg";